import $ from 'jquery';
import React, { useEffect } from 'react';
import Fancybox from "../../assets/plugins/fancybox";
import { useNavigate } from 'react-router-dom';

const ButtonBox = () => {
    const navigate = useNavigate(); 
    useEffect(() => {
        var $ytvideoTrigger = $(".ytplay-btn");
        $ytvideoTrigger.on("click", function (evt) {
            $(".ytube-video").addClass("play");
            $("#ytvideo")[0].src += "?autoplay=1";
        });

    }, []);
    return (
        <div className="button-box d-flex align-items-center flex-wrap">
            <a className="btn" onClick={() => navigate("/contact#Contact-form")}>
                <span className="btn-wrap">
                    <span className="text-one">Contact Us</span>
                    <span className="text-two">Contact Us</span>
                </span>
            </a>


        </div>
    );
};

export default ButtonBox;